export enum TenantApiUrls {
    GetTenantbyId = "Tenant/GetTenantbyId",
    GetTenantConfigurations = "/api/TenantConfiguration/GetTenantConfigurations"  
}
